import TenantLeasesList from './TenantLeasesList'

export default TenantLeasesList
